<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import UserPresenter from '@satellite/components/elements/presenters/user/UserPresenter.vue';
import useYardTaskFlaggedEvent from './useYardTaskFlaggedEvent';

import type { YardTaskTimelineEvent } from './types';

interface Props {
  event: YardTaskTimelineEvent;
  timezone: string;
  locale: string;
}

const props = defineProps<Props>();

const { t } = useI18n();
const { formattedCreatedTime, user, message } = useYardTaskFlaggedEvent(props.event, {
  timezone: props.timezone,
  locale: props.locale
});
</script>

<template>
  <div class="d-flex flex-column gap-1 align-start justify-start">
    <span class="d-flex flex-row flex-wrap align-center justify-start gap-1">
      <user-presenter
        v-if="user"
        class="typography-body-sm-bold text--color-text-secondary"
        :user="user"
        :display-fields="['name']" />
      <span class="typography-body-sm" v-if="message[0]">{{ message[0] }}</span>
      <span class="typography-body-sm-bold text-lowercase" v-if="message[1]">{{ message[1] }}</span>
    </span>
    <span v-if="formattedCreatedTime" class="typography-caption text--color-text-tertiary">
      {{ formattedCreatedTime }}
    </span>
  </div>
</template>
